function isValidDate(day, month, year) {
  if (month < 1 || month > 12) return false;
  if (day < 1) return false;

  const daysInMonth = new Date(year, month, 0).getDate(); // Get the last day of the given month
  return day <= daysInMonth;
}

function ageCheck() {
  const age_check_div = document.getElementById("age_gate");
  const birth_day_form = document.getElementById("birth_day_form");
  const age_submit_btn = document.getElementById("age_check_btn");
  const day_input = document.getElementById("age_day");
  const month_input = document.getElementById("age_month");
  const year_input = document.getElementById("age_year");

  day_input.setAttribute("min", 1);
  day_input.setAttribute("max", 31);
  month_input.setAttribute("min", 1);
  month_input.setAttribute("max", 12);
  year_input.setAttribute("min", 1900);
  year_input.setAttribute("max", new Date().getFullYear()); // No future years

  const empty_notice = document.getElementById("empty_notice");
  const wrong_value = document.getElementById("wrong_value");
  const age_message = document.getElementById("age_message");

  function resetErrors() {
    empty_notice.classList.add("age-check__none");
    wrong_value.classList.add("age-check__none");
    age_message.classList.add("age-check__none");
  }

  // Auto-focus to next input
  day_input.addEventListener("keyup", function () {
    if (this.value.length == 2) month_input.focus();
  });
  month_input.addEventListener("keyup", function () {
    if (this.value.length == 2) year_input.focus();
  });
  year_input.addEventListener("keyup", function () {
    if (this.value.length == 4) age_submit_btn.focus();
  });

  // When the submit button is clicked
  age_submit_btn.addEventListener("click", function () {
    resetErrors(); // Hide all error messages before validation

    const day = parseInt(day_input.value, 10);
    const month = parseInt(month_input.value, 10);
    const year = parseInt(year_input.value, 10);
    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 120; // Prevent unrealistically old entries

    if (!day || !month || !year) {
      empty_notice.classList.remove("age-check__none"); // Show empty field error
      return;
    }

    if (year < minYear || year > currentYear) {
      wrong_value.classList.remove("age-check__none"); // Show invalid year error
      return;
    }

    if (!isValidDate(day, month, year)) {
      wrong_value.classList.remove("age-check__none"); // Show invalid date error
      return;
    }

    const birth_second = Math.floor(
      new Date(year, month - 1, day).getTime() / 1000
    );
    const current_second = Math.floor(new Date().getTime() / 1000);
    const seconds_of_18_year = 568036800;

    if (current_second - birth_second >= seconds_of_18_year) {
      // Adult - Save verification in sessionStorage (only for this tab/session)
      sessionStorage.setItem("ageVerified", "true");
      age_check_div.style.display = "none";
    } else {
      // Not Adult
      age_message.classList.remove("age-check__none"); // Show under 18 message
      birth_day_form.classList.add("age-check__none");
      age_submit_btn.classList.add("age-check__none");
    }
  });
}

function ageGate() {
  const age_check_div = document.getElementById("age_gate");

  // Check sessionStorage instead of localStorage
  if (sessionStorage.getItem("ageVerified")) {
    age_check_div.style.display = "none"; // Already verified, hide age check
  } else {
    age_check_div.style.display = "block";
    ageCheck();
  }
}

ageGate();
